import { render, staticRenderFns } from "./NutritionTools.vue?vue&type=template&id=5a862b0d&scoped=true"
import script from "./NutritionTools.vue?vue&type=script&lang=js"
export * from "./NutritionTools.vue?vue&type=script&lang=js"
import style0 from "./NutritionTools.vue?vue&type=style&index=0&id=5a862b0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a862b0d",
  null
  
)

export default component.exports